import React, { 
    useState, 
    useEffect,
    useRef, 
    // useRef 
}  from 'react';

import shoppingCartAPI from '../../../Data/ShoppingCart';
import UtilityFunction from '../../../Util/Util';

import { connect } from 'react-redux';
import shoppingCartActions from '../../../Redux/Shopping/shopping-action'; 

import Init from '../../../Init/Init';
import Counter from '../../../Component/Utilities/Counter/Counter';
import CheckoutSection from '../../Utilities/CheckoutSection/CheckoutSection';

import NavigationContext from '../../../Context/NavigationContext';

import './ShoppingCart.scss';
import { useContext } from 'react';
import EmptyCart from '../../Utilities/EmptyCart/EmptyCart';
import PrimaryButton from '../../Utilities/PrimaryButton/PrimaryButton';

import useAnalyticsEventTracker from '../../../GoogleAnalytics/useAnalyticsEventTracker';

import transactionAPI from '../../../Data/Transaction';
import CustomToast from '../../Utilities/Toast/Toast';
import { Modal } from 'react-bootstrap';
import FormInput from '../../Utilities/FormInput/FormInput';

const GaTracker = ({
    action,
    label
}) => {
    const gaEventCategory = 'Shopping Cart';

    const gaEventTracker = useAnalyticsEventTracker(gaEventCategory);

    gaEventTracker(action, label);
};

const { FontAwesomeIcon } = Init;
const { call } = shoppingCartAPI;
const { adjustQty, saveDesignAttachment, clearCart, clearDesignAttachment } = shoppingCartActions;
const { numberFormatting } = UtilityFunction;

const ShoppingCart = (props) => {
    const { adjustQty } = props;
    const [ data, setData ] = useState([]);
    const [ totalPrice, setTotalPrice ] = useState(0);
    const [ totalShippingFee, setTotalShippingFee ] = useState(0);
    const [ onProcess, setOnProcess ] = useState(false);
    // const [ cartCounter, setCartCounter ] = useState(0);
    const [ totalQty, setTotalQty ] = useState(0);
    const [ newDesignCount, setNewDesignCount ] = useState(0);
    const [ orderToast, setOrderToast ] = useState({
        show: 0,
        status: 0,
        message: ""
    });
    const [ isCustom, setIsCustom ] = useState(false);
    
    // Design Attachment
    const [ showDesignModal, setShowDesignModal ] = useState( false );
    const designAttachmentRef = useRef({});

    // const { FontAwesomeIcon } = Init;
    const { imageFolder, requireLogin } = Init.config;
    const defaultImage = `${imageFolder}/placeholder.jpeg`;

    const navigation = useContext(NavigationContext);

    const { navigate } = navigation;

    const getCartProducts = async (cartData) => {
        let requestData = {
            id: [],
            size_id: [],
            addons: [],
            straws: []
        };

        for(let variantCode in cartData) {
            let item = cartData[variantCode];

            requestData.id.push(item.productId);
            requestData.size_id.push(item.sizeId);
        
            if( requestData.addons.indexOf(item.addons) === -1 ) {
                requestData.addons.push(parseInt(item.addons));
            }
            
            if( item.hasOwnProperty('straw') && requestData.straws.indexOf(item.straw) === -1 ) {
                requestData.straws.push(parseInt(item.straw));
            }
        }

        if(requestData.id.length > 0 && requestData.size_id.length > 0) {
            const response = await call.getCartProducts(requestData.id, requestData.size_id, requestData.addons, requestData.straws);

            if(response.hasOwnProperty('errorCode') && response.errorCode === 0) {
                return response.data;
            } 
        }

        return null;
    };

    const bindQuantity = (cartProducts, addons = {}, straws = {}) => {
        const cartData = props.cartData;
        
        for(let index in cartProducts) {
            let cartItem = cartProducts[index];
            let variantCode = UtilityFunction.base64encode(`${cartItem.product_id}-${cartItem.size_id}`);

            if(cartData.hasOwnProperty(variantCode)) {
                cartItem.quantity = cartData[variantCode].quantity;
                cartItem.isProduct = cartItem.hasOwnProperty('isProduct') ? cartItem.isProduct : true;

                if( cartData[variantCode].addons && addons.hasOwnProperty(cartData[variantCode].addons) ) {
                    cartProducts.push({
                        ...addons[cartData[variantCode].addons],
                        product_id: cartItem.product_id,
                        quantity: cartItem.quantity,
                        is_ready_stock: 1,
                        isProduct: false,
                    });
                }

                if( cartData[variantCode].straw && straws.hasOwnProperty(cartData[variantCode].straw) ) {
                    cartProducts.push({
                        ...straws[cartData[variantCode].straw],
                        product_id: cartItem.product_id,
                        quantity: cartItem.quantity % 250 === 0 ? cartItem.quantity : Math.ceil(cartItem.quantity / 250) * 250,
                        is_ready_stock: 1,
                        isProduct: false,
                    });
                }
            }

            cartProducts[index] = cartItem;
        }

        setData([...cartProducts]);
    };

    const countTotalPrice = (data) => {
        return data.reduce( (total, item) => {
            let usePrice = item.hasOwnProperty('discount_price') && item.discount_price > 0 ? item.discount_price : item.price;
            
            return total + (item.quantity * usePrice)
        }, 0);
    }

    const getTotal = (total) => {
        // return totalPrice + (totalPrice / 10);
        return (totalPrice + totalShippingFee + getAdminFee(total) + getTaxFee(total));
    }

    const getAdminFee = (total) => {
        const productionCost = getDesignFee(total);
        const mdrCost = getPlatformFee(total);

        return productionCost + mdrCost;
    }

    const getDesignFee = (total) => {
        const productionCost = props.designAttachment !== null ? newDesignCount * 80000 : 0;
        return productionCost;
    }

    const getPlatformFee = (total) => {
        const productionCost = getDesignFee();
        const totalPlusProd = totalPrice + productionCost;
        const mdrCost = Math.max(4000, ( ( (totalPlusProd + totalShippingFee) * 100 / 97.1) + 2000) - (totalPlusProd + totalShippingFee));

        return mdrCost;
    }

    const getTaxFee = (total) => {
        const productionCost = getDesignFee(total);
        return (totalPrice + productionCost) * 0.11;
    }

    useEffect( () => {
        bindQuantity(data);   
    }, [props.totalQty]);

    useEffect( () => {
        setTotalPrice(countTotalPrice(data));
    }, [data, props.totalQty]);

    useEffect( () => {
        ( async () => {
            const cartData = props.cartData;
            const cartProducts = await getCartProducts(cartData);

            if(cartProducts !== null) {
                const { products, addons, straws } = cartProducts;
                bindQuantity(products, addons, straws);
                setIsCustom( () => {
                    return products.reduce( (bool, item) => {
                        return bool || !item.is_ready_stock;
                    }, false) && props.transactionNotes !== "";
                } );
                // setTotalPrice(countTotalPrice([...products, ...Object.values(addons)]));
            } else {
                setData([]);
                setTotalPrice(0);
            }
        } )();
    }, [props.cartData, props.cartCounter] );

    useEffect( () => {
        setTotalQty(props.totalQty);
    }, [props.totalQty] );

    const checkCounter = (variantKey, quantity) => {
        let productId = data[variantKey].product_id;
        let sizeId = data[variantKey].size_id;
        let variantName = data[variantKey].product_name;
        
        const variantCode = shoppingCartAPI.controller.cartItemCode(productId, sizeId);
        let useMultiColor = props.cartData[variantCode].useMultiColor;
        let prevQty = props.cartData[variantCode].quantity;

        const ownerCode = props.identity !== undefined && props.identity.hasOwnProperty('customer_code') ? props.identity.customer_code : 'guest';

        GaTracker({
            action: `Change Counter`,
            label: `Cart Product: ${variantName}; Qty: ${quantity}`
        });
        if( useMultiColor && quantity < 1000 ) {
            quantity = quantity < prevQty ? 0 : 1000;
        }
        
        adjustQty(ownerCode, variantCode, quantity);
    };

    const checkout = (checkoutData) => {
        const isLogin = props.identity !== undefined && props.identity.hasOwnProperty('customer_code');
        if( !requireLogin || (requireLogin && isLogin) ) {
            checkoutData.transactionItems = props.cartData;
    
            // GaTracker({
            //     action: `Click Checkout Button`,
            //     label: `Initiate Checkout - ${JSON.stringify(data)}`
            // });
    
            const transactionData = {
                customerName: checkoutData.customerName,
                phoneNo: checkoutData.phoneNo,
                provinceId: checkoutData.provinceId,
                regencyId: checkoutData.regencyId,
                districtId: checkoutData.districtId,
                villageId: checkoutData.villageId,
                postalCode: checkoutData.postalCode,
                courierType: checkoutData.courierType,
                address: checkoutData.address.replaceAll("&", ""),
                recipientAccountId: checkoutData.recipientAccountId,
            };
    
            const usePaymentGateway = checkoutData.usePaymentGateway;
    
            (async() => {
                setOnProcess(true);
                const response = await transactionAPI.order({
                    transactionData,
                    transactionItems: props.cartData,
                    design_attachment: checkoutData.designAttachment,
                    usePaymentGateway,
                    transactionNotes: encodeURIComponent(props.transactionNotes)
                });
    
                if(response.hasOwnProperty('errorCode') && response.errorCode === 0) {
                    const ownerCode = props.identity !== undefined && props.identity.hasOwnProperty('customer_code') ? props.identity.customer_code : 'guest';
                    props.clearCart(ownerCode);
                    
                    if(usePaymentGateway && response.data.hasOwnProperty('paymentLink') && response.data.paymentLink !== '') {
                        window.open(response.data.paymentLink, "_blank");
                    }
    
                    // GaTracker({
                    //     action: `Create Transaction`,
                    //     label: `Checkout ${ usePaymentGateway ? 'with Xendit' : 'manually' }`
                    // });
                    
                    navigate(`/order/${response.data.transactionCode}`, {
                        replace: true,
                        state: {
                            success: 1
                        }
                    });
                } else {
                    // Display error if possible;
                    openOrderToast(0, response.message);
                    setOnProcess(false);
                }
            })();
        } else {
            // navigate('/login');
            window.location.href = "/login";
        }

    }

    // Toast
    const openOrderToast = (status, message = "") => {
        setOrderToast({
            ...orderToast,
            show: 1,
            status,
            message
        });
    }

    const closeOrderToast = () => {
        setOrderToast({
            ...orderToast,
            show: 0,
            message: ""
        });
    }

    // Update design
    const changeDesign = (file) => {
        designAttachmentRef.current = file;
        props.saveAttachment(file).then((response) => {
            setShowDesignModal(false);
        });
    }

    return (
        <>
            <CustomToast
                toastClass="order-toast"
                title={ orderToast.status ? "Success" : "Failed" }
                show={ orderToast.show }
                status={ orderToast.status }
                customClass="repeat-order-toast-content"
                onClose={() => closeOrderToast()}
            >
                <div className="order-label">
                    { orderToast.message }
                </div>
            </CustomToast>
            <Modal show={ showDesignModal } onHide={ () => setShowDesignModal(false) }>
                <Modal.Header>
                    Ubah Design
                </Modal.Header>
                <Modal.Body>
                    <FormInput 
                        attribute={{
                            label: "",
                            ref: designAttachmentRef,
                            value: props.designAttachment,
                            width: 12,
                            type: "file",
                            required: false,
                            allowedFileTypes: ['PDF', 'PSD'],
                            maxFileSize: 100 // MB
                        }}
                        options={[]}
                        name={"design_attachment"} 
                        onChange={ async (name, value) => changeDesign(value) } 
                        customClass={`custom-design-form-input`}
                    />
                </Modal.Body>
            </Modal>
            {
                data !== null &&
                data.length > 0 ? (
                    <>
                        <CheckoutSection id="section-2" 
                            checkout={ (checkoutData) => checkout(checkoutData) } 
                            onProcess={ onProcess } 
                            allowToProceed={ totalQty > 0 }
                            updateShippingFee={ (fee) => setTotalShippingFee(fee) }
                            updateDesignFee={ (value) => setNewDesignCount(value / 80000) }
                            showWarning={ (message) => openOrderToast(0, message) }
                        />
                        <div id={props.id} className={`shopping-cart-section`}>
                            <h1 className="shopping-cart-title">
                                Summary           
                            </h1>
                            <h3 className='shopping-cart-subtitle'>
                                Keranjang Belanja
                            </h3>
                            <span className='shopping-cart-caption'>
                                Anda punya { data.length } barang di keranjang Anda
                            </span>
                            <table className='shopping-cart-table'>
                                {/* <thead>
                                    <tr>
                                        <th colSpan={2}> Product </th>
                                        <th> Quantity </th>
                                        <th> Price </th>
                                    </tr>
                                </thead> */}
                                <tbody>
                                    {
                                        data !== null &&
                                        data.length > 0 &&
                                        data.map( (v, k) => {
                                            const photoPath = v.variant_image ? `${v.variant_image}` : defaultImage

                                            return (
                                                <tr key={k}>
                                                    <td className='product-photo'>
                                                        <img src={photoPath} alt="" />
                                                    </td>
                                                    <td className='product-name'>
                                                        <span className='name'>
                                                            { v.product_name }
                                                        </span>
                                                        <span className="variant">
                                                            { v.size_name }
                                                        </span>
                                                    </td>
                                                    {
                                                        v.isProduct ? (
                                                            <td className='product-qty'>
                                                                <Counter 
                                                                    size={'sm'} 
                                                                    customClass="product-qty-counter" 
                                                                    baseValue={v.quantity} 
                                                                    minValue={ (v.moq) * -1 }
                                                                    multiply={ v.moq }
                                                                    maxValue={1000}
                                                                    onModify={(quantity) => checkCounter(k, quantity)} 
                                                                    useMultiColor={ props.cartData.hasOwnProperty(v.product_id) && props.cartData[v.product_id].hasOwnProperty("useMultiColor") ? props.cartData[v.product_id].useMultiColor : false }
                                                                />
                                                            </td>
                                                        ) : (
                                                            <td className='product-qty'>
                                                                { 
                                                                    // props.cartData[v.product_id].quantity
                                                                    // props.cartData.hasOwnProperty(v.product_id) ? props.cartData[v.product_id].quantity : ""
                                                                    v.quantity 
                                                                }
                                                            </td>
                                                        )
                                                    }
                                                    <td className='product-price'>
                                                        {
                                                            v.hasOwnProperty('discount_price') && v.discount_price > 0 ? (
                                                                <>
                                                                    {/* <span className='price discounted'> { numberFormatting(v.price) } </span> <span className="price"> { numberFormatting(v.discount_price) } </span> */}
                                                                    <span className='price'>
                                                                        {
                                                                            numberFormatting(v.discount_price * v.quantity)
                                                                        }
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                <span className='price'>
                                                                    {
                                                                        numberFormatting(v.price)
                                                                    }
                                                                </span>
                                                            )
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        } )
                                    }
                                    <tr>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    {
                                        isCustom && (
                                            <>
                                                <tr className='total-info notes bold'>
                                                    <td className="total-label" colSpan={4}> 
                                                        Catatan Tambahan
                                                        <hr />    
                                                    </td>
                                                </tr>
                                                <tr className='total-info notes'>
                                                    <td className='total-label' colSpan={2}> Design </td>
                                                    <td className='total-value' colSpan={2}> 
                                                        <div className="total-value-wrapper">
                                                            { props.designAttachment && props.designAttachment instanceof File ? props.designAttachment.name : "Wajib upload file design!" }
                                                            <PrimaryButton size="sm" customClass="btn-upload" onClick={ () => setShowDesignModal(true) } >
                                                                <FontAwesomeIcon icon={['fas', 'edit']} />
                                                            </PrimaryButton>
                                                        </div>
                                                    </td>
                                                </tr>
                                                {
                                                    props.transactionNotes.split(";;").map( (item, index) => {
                                                        let splitItem = item.split(": ;");
                                                        let label = splitItem[0];
                                                        let value = splitItem[1];

                                                        return (
                                                            <tr key={index} className='total-info notes'>
                                                                <td className="total-label" colSpan={2}> { label } </td>
                                                                <td className='total-value' colSpan={2}> { value } </td>
                                                            </tr>
                                                        )
                                                    } )
                                                }
                                            </>
                                        )
                                    }
                                    <tr className='total-info total-info-header'>
                                        <td className="total-label" colSpan={4}> Rincian </td>
                                    </tr>
                                    <tr className='total-info'>
                                        <td className='total-label' colSpan={3}> Subtotal </td>
                                        <td className='total-value'> { numberFormatting(totalPrice) } </td>
                                    </tr>
                                    {/* <tr className='total-info'>
                                        <td className='total-label' colSpan={3}> Admin Fee </td>
                                        <td className='total-value'> { numberFormatting(getAdminFee(totalPrice)) } </td>
                                    </tr> */}
                                    <tr className='total-info'>
                                        <td className='total-label' colSpan={3}> Biaya Cetak </td>
                                        <td className='total-value'> { numberFormatting(getDesignFee(totalPrice)) } </td>
                                    </tr>
                                    <tr className='total-info'>
                                        <td className='total-label' colSpan={3}> Biaya Platform </td>
                                        <td className='total-value'> { numberFormatting(getPlatformFee(totalPrice)) } </td>
                                    </tr>
                                    <tr className='total-info'>
                                        <td className='total-label' colSpan={3}> PPN (11%) </td>
                                        <td className='total-value'> { numberFormatting(getTaxFee(totalPrice)) } </td>
                                    </tr>
                                    <tr className='total-info'>
                                        <td className='total-label' colSpan={3}> Ongkos Kirim </td>
                                        <td className='total-value'> { totalShippingFee > 0 ? numberFormatting(totalShippingFee) : "-" } </td>
                                    </tr>
                                    <tr className='total-info bold total'>
                                        <td className='total-label' colSpan={3}> Total </td>
                                        <td className='total-value'> { numberFormatting(getTotal(totalPrice)) } </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </>
                ) : (
                    <EmptyCart />
                )
            }
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        identity: state.auth.identity,
        cartData: state.shop.cartProducts,
        cartCounter: state.shop.cartCounter,
        totalQty: state.shop.totalQty,
        transactionNotes: state.shop.transactionNotes ?? "",
        designAttachment: state.shop.designAttachment
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        adjustQty: (ownerCode, productId, quantity) => dispatch(adjustQty(ownerCode, productId, quantity)),
        saveAttachment: async ( file ) => dispatch(await saveDesignAttachment(file)),
        clearCart: () => dispatch(clearCart()),
        clearAttachment: () => dispatch(clearDesignAttachment())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCart);